<div
	class="w-full flex text-secondary p-4 relative border border-secondary-300 rounded-xl min-h-18 resize-y bg-[var(--color-secondary-000)] transition-all"
	(keydown)="onKeyDown($event)"
	[class.border-focus!]="focused()"
	[class.bg-secondary-100]="disabled()"
	[class.text-secondary-400]="disabled()"
>
	<div (click)="onToolbarClick($event)" class="flex items-end">
		<div uiDropdown [fullWidth]="true">
			<ui-button
				icon="x_plus"
				[type]="dropdown()?.isOpen() ? 'primary' : 'link-dark'"
				uiDropdownTrigger
				class="w-10! block pb-1"
				[disabled]="disabled()"
				[uiTooltip]="'ai_chat.add_context' | translate"
				tooltipPosition="bottom"
			></ui-button>

			<ng-container *uiDropdownContent>
				@for (group of allContextGroups(); track group.mentionChannel) {
					<div
						class="flex cursor-pointer items-center gap-2 h-10 overflow-hidden px-4 user-select-none hover:bg-primary-200 whitespace-nowrap justify-between"
						(click)="addMentionFor(group.mentionChannel)"
						(keydown.enter)="addMentionFor(group.mentionChannel)"
						(keydown.space)="addMentionFor(group.mentionChannel)"
						[attr.tabindex]="0"
					>
						<span class="flex items-center gap-2">
							<ui-icon [icon]="group.icon"></ui-icon>
							{{ group.title | translate }}
						</span>
						<ui-tag [text]="group.mentionChannel" type="dark"> </ui-tag>
					</div>
				}
			</ng-container>
		</div>

		<ng-content></ng-content>
	</div>
	<quill-editor
		[modules]="quillConfig().modules"
		[formats]="quillConfig().formats"
		[placeholder]="placeholder()"
		(onEditorCreated)="editorCreated($event)"
		class="mention-editor bg-transparent w-full"
		[class.caret-transparent]="disabled()"
	></quill-editor>

	<div class="flex items-end">
		@if (isSending()) {
			<ui-button icon="stop" class="pb-1" (buttonClicked)="cancelMessage.emit()"></ui-button>
		} @else {
			<ui-button
				icon="arrow_up"
				class="pb-1"
				[disabled]="empty()"
				(buttonClicked)="sendMessage.emit()"
			></ui-button>
		}
	</div>
</div>
